import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'User.RealtorSignUpVerificationScreen.title',
    defaultMessage: 'Account Verification',
  },
  noToken: {
    id: 'User.RealtorSignUpVerificationScreen.noToken',
    defaultMessage: 'No verification token provided.',
  },
  loading: {
    id: 'User.RealtorSignUpVerificationScreen.loading',
    defaultMessage: 'Verifying your account...',
  },
  success: {
    id: 'User.RealtorSignUpVerificationScreen.success',
    defaultMessage: 'Your account has been successfully activated! Now you can log in and start using RealGenius.io.',
  },
  invalidOrExpired: {
    id: 'User.RealtorSignUpVerificationScreen.invalidOrExpired',
    defaultMessage: 'Invalid or expired code.',
  },
  genericError: {
    id: 'User.RealtorSignUpVerificationScreen.genericError',
    defaultMessage: 'An error occurred.',
  },
});

export default messages;
